import { useEffect } from "react";
import { FaTimes } from "react-icons/fa";

export const CustomModal = ({ show, onHide, size = "md", centered = true, scrollable = false, children }) => {
    // close on Escape
    useEffect(() => {
        if (!show) return;
        const onKeyDown = (e) => {
            if (e.key === "Escape") onHide?.();
        };
        document.addEventListener("keydown", onKeyDown);
        return () => document.removeEventListener("keydown", onKeyDown);
    }, [show, onHide]);

    if (!show) return null;

    const sizeClass =
        size === "2xl"
            ? "max-w-5xl"
            : size === "xl"
                ? "max-w-4xl"
                : size === "lg"
                    ? "max-w-3xl"
                    : size === "sm"
                        ? "max-w-sm"
                        : "max-w-lg";

    return (
        <div
            className={`fixed inset-0 z-50 flex ${centered ? "items-center" : "items-start pt-16"
                } justify-center p-4`}
        >
            {/* Backdrop */}
            <div
                className="absolute inset-0 bg-black/50"
                onClick={onHide}
            />

            {/* Dialog */}
            <div
                className={`relative bg-white rounded-xl shadow-xl w-full ${sizeClass} ${scrollable ? "max-h-[85vh] flex flex-col" : ""
                    }`}
                onClick={(e) => e.stopPropagation()}
            >
                {children}
            </div>
        </div>
    );
};

CustomModal.Header = ({ children, closeButton, onHide }) => (
    <div className="flex items-center justify-between px-4 py-3 border-b border-gray-200 shrink-0">
        <div>{children}</div>
        {closeButton && (
            <button
                type="button"
                onClick={onHide}
                className="text-gray-400 hover:text-gray-600 transition p-1.5 hover:bg-gray-100 rounded-md"
            >
                <FaTimes size={14} />
            </button>
        )}
    </div>
);

CustomModal.Title = ({ children, className = "" }) => (
    <div className={`font-semibold text-gray-800 ${className}`}>{children}</div>
);

CustomModal.Body = ({ children, className = "" }) => (
    <div className={`px-4 py-3 overflow-y-auto tiny-scrollbar ${className}`}>
        {children}
    </div>
);

CustomModal.Footer = ({ children, className = "" }) => (
    <div
        className={`px-4 py-3 border-t border-gray-200 shrink-0 ${className}`}
    >
        {children}
    </div>
);